// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3aH-l","title":"Images45_title__1A1V5","images":"Images45_images__2CIwp"};